import { api } from "@/redux/api";

import {
	PrivacyPolicyResponse,
	PrivacyPolicyResponseSchema,
} from "../../pages/PrivacyPolicy/schema/privacyPolicy.schema";

export const privacyPolicyApi = api.injectEndpoints({
	endpoints: (builder) => ({
		fetchPrivacyPolicy: builder.query<PrivacyPolicyResponse, void>({
			query: () => ({
				url: "privacy-policy",
				responseSchema: PrivacyPolicyResponseSchema,
			}),
		}),
	}),
});

export const { useFetchPrivacyPolicyQuery } = privacyPolicyApi;
